export const ATP_EXTENSION = ".7397C898-8104-4E2E-8926-98082ABAE229.PendingScan";
